import React, { useState, useEffect, useRef } from 'react'
import _ from 'lodash';
import { Transition } from '@headlessui/react';
import { useClickAway } from 'react-use';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import dayjs from 'dayjs';
import OpenAI from 'openai';
import {
  Modal,
  Tabs,
  Descriptions,
  Button,
  InputNumber,
  Select,
  Switch,
  Popconfirm,
  Collapse,
  Input,
  DatePicker,
  Spin,
  Popover,
  Dropdown,
  Menu,
  Divider,
  Avatar,
  Upload,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DescriptionsItem from 'antd/lib/descriptions/Item';
import Icon, { CopyOutlined, UserOutlined, PhoneOutlined, InboxOutlined } from '@ant-design/icons'; 
import { faEnvelope, faCopy, faUser, faPhone, faSearch, faMap, faCode, faTimesCircle, faBuilding, faCross, faEye, faEyeSlash } from '@fortawesome/pro-duotone-svg-icons';
import leads from './css/leads.css';
import {
  viewLeadAtom,
  notificationsAtom,
  viewLeadLogsAtom,
  viewLeadFilesAtom,
  userPrivilagesAtom,
  viewContactsAtom,
  reloadLeadsAtom,
  markLeadLostAtom,
  viewAppointmentsAtom,
  viewLeadAssignedAtom
} from '../../../../atoms/Atoms';
import {
  prMunicipalities,
  ageGroups,
  salaryGroups,
  averageMonthlyPaymentGroups,
  creditScoreGroups,
  roofTypes,
  mapContainerStyle,
  batteryBrands,
  dealTypes,
  paymentTypes,
  contactTypes,
  installers
} from '../../../../utils';
// import Input from '../../../shared-components/form/Input';
import api from '../../../../api/api';
import { checkNumber, getAge, getMobileDatePickerFooter, getWaitTimeText, isNumeric, mapAppointmentStatus, percentage, thousandAutoDecimal, toCurrency, toFormattedLocalDate, toFormattedLocalTime, toFormattedTime } from '../../../../functions';
import envConfig from '../../../../envConfig';
import LeadProgress from '../../../shared-components/leadprogress/LeadProgress';


function LeadModal() {
  const minimumSystemSize = 2000;
  const { Dragger } = Upload;
  const { Option } = Select;
  const { TabPane } = Tabs;
  const { Panel } = Collapse;
  const suggestionsRef = useRef();
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const setViewAppointments = useSetRecoilState(viewAppointmentsAtom);
  const setViewContacts = useSetRecoilState(viewContactsAtom);
  const setViewLogs = useSetRecoilState(viewLeadLogsAtom);
  const setViewFiles = useSetRecoilState(viewLeadFilesAtom);
  const setViewAssigned = useSetRecoilState(viewLeadAssignedAtom);
  const [reloadLeads, setReloadLeads] = useRecoilState(reloadLeadsAtom);
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);
  const [markLost, setMarkLost] = useRecoilState(markLeadLostAtom);
  const [lead, setLead] = useRecoilState(viewLeadAtom);
  const [leadData, setLeadData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState('');
  const [lostReason, setLostReason] = useState('');
  const [selectedTab, setSelectedTab] = useState('1');
  const [mapOpen, setMapOpen] = useState(false);
  const [state, setState] = useState({
    draggable: true,
    suggestions: [],
  });
  const [sizeCalculator, setSizeCalculator] = useState(false);
  const [panelSize, setPanelSize] = useState(0);
  const [numPanels, setNumPanels] = useState(0);
  const [openSetter, setOpenSetter] = useState(false);
  const [setters, setSetters] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchingUsers, setSearchingUsers] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [adminAllowEditDates, setAdminAllowEditDates] = useState(false);
  const [showPassword, setShowPassword] = useState({
    password: false,
    ssn: false
  });
  const client = new OpenAI({
    apiKey: envConfig.OpenAIKey,
    dangerouslyAllowBrowser: true
  });
  const defaultZoom = 11;

  const draggerProps = {
    name: 'file',
    // accept: ['image/*', '.pdf'],
    accept: ['.pdf'],
    multiple: false,
    showUploadList: true,
    maxCount: 1,
    fileList: fileData ? [fileData] : [],
    beforeUpload: (file) => {
      setFileData(file);
      return false;
    },
    ondrop: (e) => {
    },
    onRemove: (e) => {
      setFileData(null);
    }
  };

  async function analyze() {
    setUploadingFile(true);
    let inputData = { }
    if (fileData.type === 'application/pdf') {
      const file = await client.files.create({
        file: fileData,
        purpose: 'user_data',
      });
      inputData = {
        type: 'file',
        file: {
          file_id: file.id
        },
      };
    } else {
      const formdata = new FormData();
      formdata.append('file', fileData);
      const response = await api.post('leads/uploadbill', formdata);
      console.log('openai', response.data.data);
      if (response.data.success) {
        inputData = {
          type: 'image_url',
          image_url: {
            url: response.data.data,

          }
        };
      } else {
        setUploadingFile(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: t('could_not_upload_image'),
            error: true,
          },
        ]);
        return;
      }
    }
    
    const completion = await client.chat.completions.create({
      model: 'gpt-4o',
      messages: [
        {
          role: 'user',
          content: [
            inputData,
            {
              type: 'text',
              text: `Analyze the average monthly consumption and yearly consumption in kW for a given customer, and recommend the number of batteries needed to cover 12 hours of night-time consumption.\n# Steps\n1. **Average Monthly Consumption:** \n- Calculate the average monthly consumption in kilowatts (kW) using the provided data.\n2. **Yearly Consumption:**\n- Calculate the total yearly consumption in kilowatts (kW) based on the monthly consumption data.\n3. **Battery Recommendation:**\n- Determine the total kW needed to cover 12 hours of night-time consumption using the average monthly consumption data.\n- Calculate the number of batteries needed by dividing the total required kW by the capacity of each battery in watts, specified as ${panelSize}.\n# Output Format\n- Provide the average monthly consumption in kW.\n- Provide the total yearly consumption in kW.\n- Indicate the number of batteries recommended, considering the specified battery size for 12-hour coverage.\n# Notes\n- Ensure accuracy in performing arithmetic calculations and derive conclusions based on logical reasoning.\n- If the battery capacity or consumption profiles deviate significantly from average assumptions, consider additional factors.`
            }
          ]
        },
      ],
    });
    setUploadingFile(false);
    console.log('openai', completion);
    let responseContent = completion.choices[0].message.content;
    console.log('openai', responseContent);
    let promptText = '**Recommended Number of Batteries:** ';
    let index = responseContent.indexOf(promptText);
    if (index === -1) {
      promptText = '**Number of Batteries Recommended:** ';
      index = responseContent.indexOf(promptText);
    }
    if (index === -1) {
      promptText = '**Number of Batteries Needed:** ';
      index = responseContent.indexOf(promptText);
    }
    if (index === -1) {
      promptText = '**Recommended Number of Batteries Needed:** ';
      index = responseContent.indexOf(promptText);
    }
    if (index === -1) {
      promptText = '**Recommended Batteries:** ';
      index = responseContent.indexOf(promptText);
    }
    responseContent = responseContent.replace(promptText, '');
    let numberString = '';
    for (let i = index; i < responseContent.length; i++) {
      const char = responseContent[i];
      if (isNumeric(char)) {
        numberString += char;
      } else {
        i = responseContent.length;
      }
    }
    setNumPanels(parseInt(numberString, 10));
  }

  function update() {
    setLoading(true);
    api.post('leads/update', leadData)
      .then((response) => {
        setLoading(false);
        if (response?.data?.error) {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        } else {
          setNotifications([
            ...notifications,
            {
              title: t('success'),
              description: response.data.message,
              error: false,
            },
          ]);
          setReloadLeads(true);
          setLeadData({
            ...response.data.data,
            contactedOn: response.data.data.contactedOn ? dayjs(response.data.data.contactedOn).add(4, 'hour') : null,
            appointmentDateTime: response.data.data.appointmentDateTime ? dayjs(response.data.data.appointmentDateTime).add((leadData?.changedDate ? 4 : 0), 'hour') : null,
            proposalDate: response.data.data.proposalDate ? dayjs(response.data.data.proposalDate).add(4, 'hour') : null,
            signedDate: response.data.data.signedDate ? dayjs(response.data.data.signedDate).add(4, 'hour') : null,
            siteSurveyDateScheduled: response.data.data.siteSurveyDateScheduled ? dayjs(response.data.data.siteSurveyDateScheduled).add(4, 'hour') : null,
            siteSurveyDate: response.data.data.siteSurveyDate ? dayjs(response.data.data.siteSurveyDate).add(4, 'hour') : null,
            installationDate: response.data.data.installationDate ? dayjs(response.data.data.installationDate).add(4, 'hour') : null,
            installationDateScheduled: response.data.data.installationDateScheduled ? dayjs(response.data.data.installationDateScheduled).add(4, 'hour') : null,
            activationDate: response.data.data.activationDate ? dayjs(response.data.data.activationDate).add(4, 'hour') : null
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: envConfig.GoogleApiKey,
    // language: `${i18n.language}-US`,
    language: 'en-US',
    libraries: ['places']
  });

  const apiHasLoaded = (map) => {
    const placesService = new window.google.maps.places.PlacesService(map);
    const autocompleteService = new window.google.maps.places.AutocompleteService();
    if (leadData?.location?.lat && leadData?.location?.lon) {
      const bounds = new window.google.maps.LatLngBounds({
        lat: leadData?.location?.lat,
        lng: leadData?.location?.lon,
      });
      map.fitBounds(bounds);
      map.setZoom(defaultZoom);
    }
    setState({
      ...state,
      mapApiLoaded: true,
      mapInstance: map,
      placesService,
      autocompleteService,
    });
    setAddress('');
  };

  const fetchPredictions = () => {
    if (address.length && state.mapApiLoaded) {
      state.autocompleteService.getPlacePredictions(
        {
          input: address,
          componentRestrictions: { country: 'pr' },
        },
        (predictions, status) => {
          if (status !== 'OK') {
            return;
          }

          setState({
            ...state,
            suggestions: predictions,
          });
        }
      );
    } else {
      setState({
        ...state,
        suggestions: [],
      });
    }
  };

  const getDetails = (placeId) => {
    state.placesService.getDetails(
      {
        placeId,
        fields: [
          'name',
          'address_components',
          'formatted_address',
          'geometry',
          'place_id',
        ],
      },
      (result, status) => {
        if (status === 'OK') {
          state.mapInstance.fitBounds(result.geometry.viewport);
          _.each(result.address_components, (component) => {
            if (component.types[0] === 'locality') {
              const muns = _.filter(prMunicipalities, (mun) => mun === component.long_name);
              if (muns?.length > 0) {
                return setLeadData({
                  ...leadData,
                  municipality: component.long_name
                });
              }
            }
            return null;
          });
          setLeadData({
            ...leadData,
            location: {
              ...leadData?.location,
              lat: result.geometry.location.lat(),
              lon: result.geometry.location.lng()
            }
          });
          setState({
            ...state,
            draggable: true,
            suggestions: [],
          });
          setAddress('');
        }
      }
    );
  };

  const setMunicipalityCoords = () => {
    state.autocompleteService.getPlacePredictions(
      {
        input: leadData?.municipality,
        componentRestrictions: { country: 'pr' },
      },
      (predictions, predictionStatus) => {
        if (predictionStatus !== 'OK') {
          return;
        }
        if (predictions?.length > 0) {
          const placeId = predictions[0].place_id;
          state.placesService.getDetails(
            {
              placeId,
              fields: [
                'name',
                'address_components',
                'formatted_address',
                'geometry',
                'place_id',
              ],
            },
            (detailsResult, detailsStatus) => {
              if (detailsStatus === 'OK') {
                state.mapInstance.fitBounds(detailsResult.geometry.viewport);
                setLeadData({
                  ...leadData,
                  location: {
                    ...leadData?.location,
                    lat: detailsResult.geometry.location.lat(),
                    lon: detailsResult.geometry.location.lng()
                  }
                });
              }
            }
          );
        }
      }
    );
  };

  function searchSetters() {
    if (searchText?.length > 0) {
      setSearchingUsers(true);
      api
        .post('leads/setters/search', { Query: searchText, OrganizationReferralCode: lead?.referralCode })
        .then((response) => {
          setSearchingUsers(false);
          if (response?.data?.success) {
            setSetters(response.data.data.users);
          } else {
            setNotifications([
              ...notifications,
              {
                title: t('error'),
                description: response?.data?.error,
                error: true,
              },
            ]);
          }
        })
        .catch((error) => {
          setSearchingUsers(false);
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: error.message,
              error: true,
            },
          ]);
        });
    } else {
      setSetters([]);
    }
  }

  function assignSetter(user) {
    setLoading(true);
    api.post('leads/assign/setter', { UserId: user?.id, LeadId: leadData?.id })
    .then((response) => {
      setLoading(false);
      if (response.data.success) {
        setLeadData({
          ...leadData,
          setterId: response.data.data.setterId,
          setter: response.data.data.setter
        });
        setReloadLeads(true);
        if (response.data.message) {
          setNotifications([
            ...notifications,
            {
              title: t('yay'),
              description: response?.data?.message,
              error: false,
            },
          ]);
        }
      } else {
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: response?.data?.error,
            error: true,
          },
        ]);
      }
    })
    .catch((error) => {
      setSearchingUsers(false);
      setNotifications([
        ...notifications,
        {
          title: t('error'),
          description: error.message,
          error: true,
        },
      ]);
    });
  }

  function removeSetter() {
    setLoading(true);
    api.delete(`leads/remove/setter/${leadData?.id}`)
    .then((response) => {
      setLoading(false);
      if (response.data.success) {
        setLeadData({
          ...leadData,
          setterId: response.data.data.setterId,
          setter: response.data.data.setter
        });
        setReloadLeads(true);
        if (response.data.message) {
          setNotifications([
            ...notifications,
            {
              title: t('yay'),
              description: response?.data?.message,
              error: false,
            },
          ]);
        }
      } else {
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: response?.data?.error,
            error: true,
          },
        ]);
      }
    })
    .catch((error) => {
      setSearchingUsers(false);
      setNotifications([
        ...notifications,
        {
          title: t('error'),
          description: error.message,
          error: true,
        },
      ]);
    });
  }

  function getLeadData() {
    if (leadData) {
      api.get(`leads/lead/${leadData.id}`)
      .then((response) => {
        if (response.success) {
          setLeadData({
            ...leadData,
            appointments: response.data.appointments,
            assignments: response.data.assignments,
            requests: response.data.requests,
            files: response.data.files,
            setter: response.data.setter
          });
        }
      })
    }
  }

  useEffect(() => {
    if (reloadLeads) {
      getLeadData();
    }
  }, [reloadLeads]);

  useEffect(() => {
    setSetters([]);
    setSearchText('');
  }, [openSetter]);

  useEffect(() => {
    fetchPredictions();
  }, [address]);

  useEffect(() => {
    if (leadData?.municipality && state.mapApiLoaded) {
      setMunicipalityCoords();
    }
  }, [leadData?.municipality]);

  // useEffect(() => {
  //   if (reloadLeads) {
  //     getLead();
  //     setTimeout(() => {
  //       setReloadLeads(false);
  //     }, 500);
  //   }
  // }, [reloadLeads]);

  useEffect(() => {
    console.log('lead', lead);
    setLostReason('');
    if (lead && !markLost?.reload) {
      setSelectedTab('1');
      setAddress('');
      setMapOpen(false);
      setOpen(true);
      setLeadData(lead);
    } else if (!markLost?.reload) {
      setOpen(false);
      setLeadData(null);
    }
  }, [lead]);

  useEffect(() => {
    setPanelSize(0);
    setNumPanels(0);
    setFileData(null);
    setUploadingFile(false);
  }, [sizeCalculator]);

  useEffect(() => {
    if (markLost?.reload) {
      setReloadLeads(true);
      setMarkLost({
        ...markLost,
        reload: false
      });
    }
  }, [markLost?.reload]);

  useClickAway(suggestionsRef, () => {
    setState({
      ...state,
      suggestions: [],
    });
  });
  return (
    <>
      <Modal
        title={(
          <div className="flex flex-col">
            <div className="flex flex-col md:flex-row">
              <LeadProgress lead={leadData} />
              <div className="mt-6 mb-2 md:mt-0 md:w-1/2">  
                  {leadData?.setter && (
                    <div className="mt-1">
                      <span className="setter-label md:mx-2 text-white rounded rounded-xl ring ring-xl ring-offset-1 px-2">{t('setter')} - {leadData?.setter?.completeName}</span>
                    </div>
                  )}
                    {!leadData?.setter && (
                    <div className="mt-1">
                      <span className="setter-label md:mx-2 text-white rounded rounded-xl ring ring-xl ring-offset-1">{t('self-gen')}</span>
                    </div>
                  )}            
              </div>
            </div>
            <div>{leadData?.submittedBy && (
              <div className="space-x-2">
                <span className="text-lg py-2 font-bold mt-4 md:mt-0">
                  {/* <Avatar src={leadData?.submittedBy?.avatar} className="bg-primaryColor w-8 mr-2" /> */}
                  {leadData?.submittedBy?.completeName}
                </span>
                <span className="text-md py-2 mt-4 md:mt-0">
                  {leadData?.submittedBy?.birthdate ? `${getAge(leadData?.submittedBy?.birthdate, t)} (${toFormattedLocalDate(leadData?.submittedBy?.birthdate)})` : t('no_birthdate_set')}
                </span>
              </div>
              
            )}
            </div>
            <Divider className="bg-blue-400" />
          </div>
        )}
        width="100%"
        zIndex={998}
        open={open}
        onCancel={() => {
          setLead(null);
        }}
        footer={[
          <div key="footer" className="grid grid-cols-1 md:grid md:grid-cols-1 md:gap-2 md:gap-0">
            <div
              className={!userPrivilages.hasOrganizationAdminPrivilages ? 'hidden col-span-2' : 'space-x-2 col-span-2'}
            >
              <span>{t('edit_dates')}</span>
              <Switch
                disabled={!userPrivilages.hasOrganizationAdminPrivilages}
                checked={adminAllowEditDates}
                onChange={(obj) => setAdminAllowEditDates(obj)}
              />
            </div>
            <div className="flex md:space-x-2 space-y-4 mt-4 md:ml-auto md:flex-row flex-col items-center space-y-2 md:space-y-0">
              <Button
                key="lost"
                danger
                type="primary"
                className={lead?.asSetter ? 'hidden' : 'w-full md:w-auto'}
                onClick={() => setMarkLost(leadData)}
                disabled={lead?.asSetter || loading || leadData?.status === 11}
              >
                {t('lost')}
              </Button>
              <Button
                key="logs"
                type="primary"
                className="w-full md:w-auto"
                disabled={loading || leadData?.status === 11}
                onClick={() => setViewLogs(lead)}
              >
                {t('notes')} {leadData?.logCount > 0 ? `(${leadData?.logCount})` : ''}
              </Button>
              <Button
                key="appointments"
                type="primary"
                className="w-full md:w-auto"
                disabled={loading || leadData?.status === 11}
                onClick={() => setViewAppointments(lead)}
              >
                {t('appointments')} {leadData?.appointments?.length > 0 ? `(${leadData?.appointments?.length})` : ''}
              </Button>
              <Button
                key="files"
                type="primary"
                className="w-full md:w-auto"
                disabled={loading || leadData?.status === 11}
                onClick={() => setViewFiles(lead)}
              >
                {t('files')} {leadData?.fileCount > 0 ? `(${leadData?.fileCount})` : ''}
              </Button>
              <Button
                key="contacts"
                type="primary"
                className="w-full md:w-auto"
                disabled={loading || leadData?.status === 11}
                onClick={() => setViewContacts(lead)}
              >
                {t('contacts')} {leadData?.additionalContactsCount > 0 ? `(${leadData?.additionalContactsCount})` : ''}
              </Button>
              <Button
                key="setter"
                type="primary"
                className={lead?.asSetter ? 'hidden' : 'w-full md:w-auto'}
                disabled={lead?.asSetter || loading || leadData?.status === 11}
                onClick={() => setOpenSetter(true)}
              >
                {t('setter')}
              </Button>
              <Button
                key="setter"
                type="primary"
                className={lead?.asSetter ? 'hidden' : 'w-full md:w-auto'}
                disabled={lead?.asSetter || loading || leadData?.status === 11 || !userPrivilages.hasLeadManager}
                onClick={() => {
                  setViewAssigned({
                    ...leadData,
                    referralCode: leadData?.referredBy?.referralCode
                  });
                }}
              >
                {t('reassign')}
              </Button>
              <Popconfirm
                title={t('are_you_sure_update_lead_prompt')}
                okText={t('yes')}
                cancelText={t('no')}
                onConfirm={() => update()}
              >
                <Button
                  key="ok"
                  type="primary"
                  loading={loading}
                  className={lead?.asSetter ? 'hidden' : 'w-full md:w-auto h-8'}
                  disabled={userPrivilages.hasOnlySetter}
                >
                  {t('update')}
                </Button>
              </Popconfirm>
            </div>
          </div>
        ]}
      >
        {(leadData && leadData !== null) && (
          <Spin spinning={loading}>
            <div className="flex flex-col md:flex-row block">
              <p className="hidden">
                <FontAwesomeIcon icon={faUser} style={{ marginRight: 8 }} />
                {leadData?.submittedBy.completeName}
                <Button
                  className="ml-2 text-primaryColor text-sm"
                  icon={<CopyOutlined />}
                  onClick={() => navigator.clipboard.writeText(leadData?.completeName)}
                />
              </p>
              <p>
                <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: 8 }} />
                {leadData?.submittedBy.email}
                <Button
                  className="ml-2 text-primaryColor text-sm"
                  icon={<CopyOutlined />}
                  onClick={() => navigator.clipboard.writeText(leadData?.submittedBy.email)}
                />
              </p>
              <p>
                <FontAwesomeIcon className="md:ml-4" icon={faPhone} style={{ marginRight: 8 }} />
                <a href={`tel:${leadData?.submittedBy.phone}`}>{leadData?.submittedBy.phone}</a>
                <Button
                  className="ml-2 text-primaryColor text-sm"
                  icon={<CopyOutlined />}
                  onClick={() => navigator.clipboard.writeText(leadData?.submittedBy.phone)}
                />
              </p>
              {leadData?.externalDealId && 
              <p>
                <FontAwesomeIcon className="md:ml-4" icon={faCode} style={{ marginRight: 8 }} />
                <a href={`tel:${leadData?.submittedBy.phone}`}>{leadData?.externalDealId}</a>
                <Button
                  className="ml-2 text-primaryColor text-sm"
                  icon={<CopyOutlined />}
                  onClick={() => navigator.clipboard.writeText(leadData?.externalDealId)}
                />
              </p>}
              <p className="mt-1">
                <FontAwesomeIcon className="md:ml-8" icon={faBuilding} style={{ marginRight: 8 }} />
                <a href="tel:18889974469">Call Bright Ops</a>
              </p>
              {/* <p className="mt-1 ml-2 bill_button">
              {_.filter(leadData?.files, (f) => f.type === t('bill')).length > 0 && (
                <a target="_blank" rel="noreferrer" href={_.filter(leadData?.files, (f) => f.type === t('bill'))[0]}>{t('bill')}</a>
              )}
              </p> */}
            </div>
            <Tabs
              activeKey={selectedTab}
              onChange={(e) => setSelectedTab(e)}
              className="min-h-3/4"
            >
             {/* Tab 1: Deal Workflow */}
             <TabPane tab={t('deal_workflow')} key="1">
               <Descriptions bordered>
                {/* <DescriptionsItem label={t('assigned_on')}>
                  <p>{leadData?.assignedOn ? toFormattedLocalTime(leadData?.assignedOn) : '-'}</p>
                </DescriptionsItem> */}
                <DescriptionsItem label={t('contacted_on')}>
                  {adminAllowEditDates && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          contactedOn: date
                        })
                      }}
                      value={leadData?.contactedOn ? dayjs(leadData?.contactedOn) : null}
                      showSecond={false}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                  {!adminAllowEditDates && leadData?.contactedOn && leadData?.status >= 2 && (
                    <span>{toFormattedLocalDate(dayjs(leadData?.contactedOn))}</span>
                  )}
                  {!adminAllowEditDates && leadData?.contactedOn && leadData?.status === 1 && (
                    <div className="flex space-x-2 text-center">
                      <span className="mt-2">{toFormattedLocalDate(dayjs(leadData?.contactedOn))}</span>
                      <Button
                        className="border-none"
                        onClick={() => setLeadData({
                          ...leadData,
                          contactedOn: null
                        })}
                      >
                        <FontAwesomeIcon icon={faTimesCircle} className="text-red-400" />
                      </Button>
                    </div>
                  )}
                  {!adminAllowEditDates && !leadData?.contactedOn && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          contactedOn: dayjs(date).add(4, 'hour')
                        })
                      }}
                      showSecond={false}
                      disabled={lead?.asSetter || loading || !leadData?.status === 0}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                </DescriptionsItem>
                <DescriptionsItem label={t('appointment_date')}>
                  {leadData?.appointments?.length > 0 && (
                    <span>{toFormattedLocalTime(dayjs(leadData?.appointments[0].appointmentDate))}</span>
                  )}
                  {leadData?.appointments?.length === 0 && (
                    <span>-</span>
                  )}
                </DescriptionsItem>
                <DescriptionsItem label={t('appointment_status')}>
                  {leadData?.appointments?.length > 0 && (
                    <span>{t(mapAppointmentStatus(leadData?.appointments[0].appointmentStatus))}</span>
                  )}
                  {leadData?.appointments?.length === 0 && (
                    <span>{t('not_held')}</span>
                  )}
                </DescriptionsItem>
                <DescriptionsItem label={t('proposal_date')}>
                  {adminAllowEditDates && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      minuteStep={15}
                      value={leadData?.proposalDate ? dayjs(leadData?.proposalDate) : null}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          proposalDate: date
                        })
                      }}
                      showSecond={false}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                  {!adminAllowEditDates && leadData?.proposalDate && leadData?.status >= 4 && (
                    <span>{toFormattedLocalDate(dayjs(leadData?.proposalDate))}</span>
                  )}
                  {!adminAllowEditDates && leadData?.proposalDate && leadData?.appointmentStatus === 1 && leadData?.status === 3 && (
                    <div className="flex space-x-2 text-center">
                      <span className="mt-2">{toFormattedLocalDate(dayjs(leadData?.proposalDate))}</span>
                      <Button
                        className="border-none"
                        onClick={() => setLeadData({
                          ...leadData,
                          proposalDate: null
                        })}
                      >
                        <FontAwesomeIcon icon={faTimesCircle} className="text-red-400" />
                      </Button>
                    </div>
                  )}
                  {!adminAllowEditDates && !leadData?.proposalDate && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      minuteStep={15}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          proposalDate: dayjs(date).add(4, 'hour')
                        })
                      }}
                      showSecond={false}
                      disabled={lead?.asSetter || loading || leadData?.appointmentStatus !== 1 || leadData?.status < 3 || leadData?.status === 11}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                </DescriptionsItem>
                <DescriptionsItem label={t('signed_date')}>
                  {adminAllowEditDates && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      minuteStep={15}
                      value={leadData?.signedDate ? dayjs(leadData?.signedDate) : null}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          signedDate: date
                        })
                      }}
                      showSecond={false}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                  {!adminAllowEditDates && leadData?.signedDate && leadData?.status >= 5 && (
                    <span>{toFormattedLocalDate(dayjs(leadData?.signedDate))}</span>
                  )}
                  {!adminAllowEditDates && leadData?.signedDate && leadData?.status === 4 && (
                    <div className="flex space-x-2 text-center">
                      <span className="mt-2">{toFormattedLocalDate(dayjs(leadData?.signedDate))}</span>
                      <Button
                        className="border-none"
                        onClick={() => setLeadData({
                          ...leadData,
                          signedDate: null
                        })}
                      >
                        <FontAwesomeIcon icon={faTimesCircle} className="text-red-400" />
                      </Button>
                    </div>
                  )}
                  {!adminAllowEditDates && !leadData?.signedDate && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      minuteStep={15}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          signedDate: dayjs(date).add(4, 'hour')
                        })
                      }}
                      showSecond={false}
                      disabled={lead?.asSetter || loading || leadData?.status < 4 || leadData?.status === 11}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                </DescriptionsItem>
                <DescriptionsItem label={t('validation_call')}>
                  <div className="flex">
                    <Switch
                      checked={leadData?.validationCall}
                      className="mx-auto"
                      onChange={(checked) => setLeadData({
                        ...leadData,
                        validationCall: checked
                      })}
                    />
                  </div>
                </DescriptionsItem>
                <DescriptionsItem label={t('auto_pay')}>
                  <div className="flex">
                    <Switch
                      checked={leadData?.autoPay}
                      className="mx-auto"
                      onChange={(checked) => setLeadData({
                        ...leadData,
                        autoPay: checked
                      })}
                    />
                  </div>
                </DescriptionsItem>
                <DescriptionsItem label={t('site_survey_date')}>
                  {adminAllowEditDates && (
                    <DatePicker
                      showTime={{ use12Hours: true }}
                      format="YYYY-MM-DD hh:mm a"
                      className="w-full"
                      showHour
                      inputReadOnly
                      showMinute
                      minuteStep={15}
                      value={leadData?.siteSurveyDateScheduled ? dayjs(leadData?.siteSurveyDateScheduled) : null}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          siteSurveyDateScheduled: date
                        })
                      }}
                      showSecond={false}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                  {!adminAllowEditDates && leadData?.siteSurveyDateScheduled && leadData?.status >= 6 && (
                    <span>{toFormattedLocalTime(dayjs(leadData?.siteSurveyDateScheduled))}</span>
                  )}
                  {!adminAllowEditDates && leadData?.siteSurveyDateScheduled && leadData?.status === 5 && (
                    <div className="flex space-x-2 text-center">
                      <span className="mt-2">{toFormattedTime(dayjs(leadData?.siteSurveyDateScheduled))}</span>
                      <Button
                        className="border-none"
                        onClick={() => setLeadData({
                          ...leadData,
                          siteSurveyDateScheduled: null
                        })}
                      >
                        <FontAwesomeIcon icon={faTimesCircle} className="text-red-400" />
                      </Button>
                    </div>
                  )}
                  {!adminAllowEditDates && !leadData?.siteSurveyDateScheduled && (
                    <DatePicker
                      showTime={{ use12Hours: true }}
                      format="YYYY-MM-DD hh:mm a"
                      className="w-full"
                      showHour
                      inputReadOnly
                      showMinute
                      minuteStep={15}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          siteSurveyDateScheduled: dayjs(date).add(4, 'hour')
                        })
                      }}
                      showSecond={false}
                      disabled={lead?.asSetter || loading || leadData?.status < 5 || leadData?.status === 11}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                </DescriptionsItem>
                <DescriptionsItem label={t('site_survey_completed')}>
                  {adminAllowEditDates && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      value={leadData?.siteSurveyDate ? dayjs(leadData?.siteSurveyDate) : null}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          siteSurveyDate: date
                        })
                      }}
                      showSecond={false}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                  {!adminAllowEditDates && leadData?.siteSurveyDate && leadData?.status >= 6 && (
                    <span>{toFormattedLocalDate(dayjs(leadData?.siteSurveyDate))}</span>
                  )}
                  {!adminAllowEditDates && leadData?.siteSurveyDate && leadData?.status === 5 && (
                    <div className="flex space-x-2 text-center">
                      <span className="mt-2">{toFormattedLocalDate(dayjs(leadData?.siteSurveyDate))}</span>
                      <Button
                        className="border-none"
                        onClick={() => setLeadData({
                          ...leadData,
                          siteSurveyDate: null
                        })}
                      >
                        <FontAwesomeIcon icon={faTimesCircle} className="text-red-400" />
                      </Button>
                    </div>
                  )}
                  {!adminAllowEditDates && !leadData?.siteSurveyDate && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          siteSurveyDate: dayjs(date).add(4, 'hour')
                        })
                      }}
                      showSecond={false}
                      disabled={lead?.asSetter || loading || leadData?.status < 5 || leadData?.status === 11}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                </DescriptionsItem>
                <DescriptionsItem label={t('installation_date')}>
                  {adminAllowEditDates && (
                    <DatePicker
                      showTime={{ use12Hours: true }}
                      format="YYYY-MM-DD hh:mm a"
                      className="w-full"
                      showHour
                      inputReadOnly
                      showMinute
                      minuteStep={15}
                      value={leadData?.installationDateScheduled ? dayjs(leadData?.installationDateScheduled) : null}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          installationDateScheduled: date
                        })
                      }}
                      showSecond={false}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                  {!adminAllowEditDates && leadData?.installationDateScheduled && leadData?.status >= 8 && (
                    <span>{toFormattedLocalTime(dayjs(leadData?.installationDateScheduled))}</span>
                  )}
                  {!adminAllowEditDates && leadData?.installationDateScheduled && leadData?.status === 7 && (
                    <div className="flex space-x-2 text-center">
                      <span className="mt-2">{toFormattedTime(dayjs(leadData?.installationDateScheduled))}</span>
                      <Button
                        className="border-none"
                        onClick={() => setLeadData({
                          ...leadData,
                          installationDateScheduled: null
                        })}
                      >
                        <FontAwesomeIcon icon={faTimesCircle} className="text-red-400" />
                      </Button>
                    </div>
                  )}
                  {!adminAllowEditDates && !leadData?.installationDateScheduled && (
                    <DatePicker
                      showTime={{ use12Hours: true }}
                      format="YYYY-MM-DD hh:mm a"
                      className="w-full"
                      showHour
                      inputReadOnly
                      showMinute
                      minuteStep={15}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          installationDateScheduled: dayjs(date).add(4, 'hour')
                        })
                      }}
                      showSecond={false}
                      disabled={lead?.asSetter || loading || leadData?.status < 7 || leadData?.status === 11}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                </DescriptionsItem>
                <DescriptionsItem label={t('installation_completed')}>
                  {adminAllowEditDates && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      value={leadData?.installationDate ? dayjs(leadData?.installationDate) : null}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          installationDate: date
                        })
                      }}
                      showSecond={false}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                  {!adminAllowEditDates && leadData?.installationDate && leadData?.status >= 9 && (
                    <span>{toFormattedLocalDate(dayjs(leadData?.installationDate))}</span>
                  )}
                  {!adminAllowEditDates && leadData?.installationDate && leadData?.status === 8 && (
                    <div className="flex space-x-2 text-center">
                      <span className="mt-2">{toFormattedLocalDate(dayjs(leadData?.installationDate))}</span>
                      <Button
                        className="border-none"
                        onClick={() => setLeadData({
                          ...leadData,
                          installationDate: null
                        })}
                      >
                        <FontAwesomeIcon icon={faTimesCircle} className="text-red-400" />
                      </Button>
                    </div>
                  )}
                  {!adminAllowEditDates && !leadData?.installationDate && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          installationDate: dayjs(date).add(4, 'hour')
                        })
                      }}
                      showSecond={false}
                      disabled={lead?.asSetter || loading || leadData?.status < 8 || leadData?.status === 11}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                </DescriptionsItem>
                <DescriptionsItem label={t('activation_date')}>
                  {adminAllowEditDates && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      value={leadData?.activationDate ? dayjs(leadData?.activationDate) : null}
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          activationDate: date
                        })
                      }}
                      showSecond={false}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                  {!adminAllowEditDates && leadData?.activationDate && leadData?.status === 10 && (
                    <span>{toFormattedLocalDate(dayjs(leadData?.activationDate))}</span>
                  )}
                  {!adminAllowEditDates && leadData?.activationDate && leadData?.status === 9 && (
                    <div className="flex space-x-2 text-center">
                      <span className="mt-2">{toFormattedLocalDate(dayjs(leadData?.activationDate))}</span>
                      <Button
                        className="border-none"
                        onClick={() => setLeadData({
                          ...leadData,
                          activationDate: null
                        })}
                      >
                        <FontAwesomeIcon icon={faTimesCircle} className="text-red-400" />
                      </Button>
                    </div>
                  )}
                  {!adminAllowEditDates && !leadData?.activationDate && (
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          activationDate: dayjs(date).add(4, 'hour')
                        })
                      }}
                      showSecond={false}
                      disabled={lead?.asSetter || loading || leadData?.status < 9 || leadData?.status === 11}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  )}
                </DescriptionsItem>
                  {leadData?.status === 11 && (
                    <DescriptionsItem label={t('lost_date')}>
                      <span>{toFormattedLocalTime(dayjs(leadData?.lostDate))}</span>
                    </DescriptionsItem>
                  )}
               </Descriptions>
             </TabPane>
             
             {/* Tab 2: Location */}
             <TabPane tab={t('location')} key="2">
               <Descriptions bordered>   
                 <DescriptionsItem span={2} label={t('location')}>
                   <div className="grid gap-2 grid-cols-1 md:grid-cols-2 lg:grid-cols-7">
                     <div className="col-span-1 lg:col-span-3">
                       <span>{t('latitude')}</span>
                       <div className="flex">
                         <InputNumber
                           value={leadData?.location.lat}
                           disabled={lead?.asSetter || loading || leadData?.status === 11 || userPrivilages?.hasOnlySetter}
                           className="w-full"
                           step="0.01"
                           formatter={(value) => thousandAutoDecimal(value)}
                           parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                           onChange={(obj) => setLeadData({
                             ...leadData,
                             location: {
                               ...leadData.location,
                               lat: obj
                             }
                           })}
                         />
                         <Button
                           className="ml-2"
                           icon={<CopyOutlined />}
                           onClick={() => navigator.clipboard.writeText(leadData?.location.lat)}
                         />
                       </div>
                     </div>
                     <div className="col-span-1 lg:col-span-3">
                       <span>{t('longitude')}</span>
                       <div className="flex">
                         <InputNumber
                           value={leadData?.location.lon}
                           disabled={lead?.asSetter || loading || leadData?.status === 11 || userPrivilages?.hasOnlySetter}
                           className="w-full"
                           step="0.01"
                           formatter={(value) => thousandAutoDecimal(value)}
                           parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                           onChange={(obj) => setLeadData({
                             ...leadData,
                             location: {
                               ...leadData.location,
                               lon: obj
                             }
                           })}
                         />
                         <Button
                           className="ml-2"
                           icon={<CopyOutlined />}
                           onClick={() => navigator.clipboard.writeText(leadData?.location.lon)}
                         />
                       </div>
                     </div>
                     <div className="col-span-1 md:col-span-2 lg:col-span-1">
                      <br className="hidden lg:block" />
                       <Button
                         className="w-full lg:w-auto lg:ml-2"
                         icon={<CopyOutlined />}
                         onClick={() => navigator.clipboard.writeText(`${leadData?.location.lat},${leadData?.location.lon}`)}
                       >
                         {t('copy_lat_lon')}
                       </Button>
                     </div>
                     <Collapse activeKey={mapOpen ? ['1'] : []} onChange={() => setMapOpen(!mapOpen)} className="col-span-1 md:col-span-2 lg:col-span-7">
                       <Panel
                         key="1"
                         header={(
                           <div className="flex space-x-1">
                             <FontAwesomeIcon className="mt-1" icon={faMap} />
                             <span>{t('map')}</span>
                           </div>
                         )}
                       >
                         <div className="relative text-center mt-4">
                           <span>{t('move_marker_on_map_or_search')}</span>
                           <div className="flex">
                             <Input
                               icon={faSearch}
                               value={address}
                               onChange={(obj) => setAddress(obj.target.value)}
                             />
                           </div>
                           <Transition
                             appear={state.suggestions.length > 0}
                             show={state.suggestions.length > 0}
                             enter="transform transition duration-500"
                             enterFrom="opacity-0 -translate-y-50"
                             enterTo="opacity-100 -translate-y-0"
                             leave="transform transition duration-150"
                             leaveFrom="opacity-100"
                             leaveTo="opacity-0"
                             className="absolute z-10 mt-2 w-full divide-y divide-gray-100 shadow-xl bg-white px-4"
                           >
                             {_.map(state.suggestions, (suggestion) => (
                               <button
                                 key={suggestion.place_id}
                                 type="button"
                                 onClick={() => getDetails(suggestion.place_id)}
                                 className="text-gray-400 hover:text-gray-500 text-xs text-left block w-full py-4 px-4 truncate ring-0 focus:ring-0 outline-none focus:outline-none transition duration-200 ease-linear cursor-pointer"
                               >
                                 {suggestion.description}
                               </button>
                             ))}
                           </Transition>
                           <GoogleMap
                             mapContainerStyle={mapContainerStyle}
                             zoomControl
                             mapTypeId="satellite"
                             draggable
                             center={{
                               lat: leadData?.location?.lat,
                               lng: leadData?.location?.lon,
                             }}
                             zoom={defaultZoom}
                             onLoad={apiHasLoaded}
                           >
                             <Marker
                               draggable={!leadData?.asSetter && leadData?.status !== 11 && leadData?.status !== 10}
                               position={{ lat: leadData?.location?.lat, lng: leadData?.location?.lon }}
                               onDragEnd={(coords) => {
                                if (!leadData?.asSetter && leadData?.status !== 11 && leadData?.status !== 10) {
                                  const lat = coords.latLng.lat();
                                  const lon = coords.latLng.lng();
                                  setLeadData({
                                    ...leadData,
                                    location: {
                                      ...leadData.location,
                                      lon,
                                      lat
                                    }
                                  });
                                }
                               }}
                             />
                           </GoogleMap>
                         </div>
                       </Panel>
                     </Collapse>
                   </div>
                 </DescriptionsItem>
                 <DescriptionsItem span={2} label={t('address')}>
                  <div className="space-y-2">
                    <Input
                      className="p-2"
                      value={leadData?.addressLine1}
                      disabled={lead?.asSetter || loading || leadData?.status === 11}
                      onChange={(obj) => setLeadData({
                        ...leadData,
                        addressLine1: obj.target.value
                      })}
                    />
                    <Input
                      className="p-2"
                      value={leadData?.addressLine2}
                      disabled={lead?.asSetter || loading || leadData?.status === 11}
                      onChange={(obj) => setLeadData({
                        ...leadData,
                        addressLine2: obj.target.value
                      })}
                    />
                  </div>
                 </DescriptionsItem>
                 <DescriptionsItem span={2} label={t('municipality')}>
                   <Select
                     showSearch
                     className="w-full h-12"
                     filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
                     value={leadData?.municipality}
                     disabled={lead?.asSetter || loading || leadData?.status === 11}
                     onChange={(obj) => setLeadData({
                       ...leadData,
                       municipality: obj
                     })}
                   >
                     {_.map(prMunicipalities, (mun) => (
                       <Option value={mun}>{mun}</Option>
                     ))}
                   </Select>
                 </DescriptionsItem>
                 <DescriptionsItem span={2} label={t('country')}>
                   <Input
                     value={leadData?.country}
                     disabled={lead?.asSetter || loading || leadData?.status === 11}
                     onChange={(obj) => setLeadData({
                       ...leadData,
                       country: obj.target.value
                     })}
                   />
                 </DescriptionsItem>
                 <DescriptionsItem span={2} label={t('zipcode')}>
                   <Input
                     value={leadData?.zipcode}
                     disabled={lead?.asSetter || loading || leadData?.status === 11}
                     onChange={(obj) => setLeadData({
                       ...leadData,
                       zipcode: obj.target.value
                     })}
                   />
                 </DescriptionsItem>
               </Descriptions>
             </TabPane>
             
             {/* Tab 3: System */}
             <TabPane tab={t('system')} key="3">   
               <Descriptions className="flex flex-col grid grid-cols-1" bordered>     
                 <DescriptionsItem label={t('gross_deal_amount')}>
                   <InputNumber
                     value={leadData?.grossDealAmount}
                     disabled={lead?.asSetter || loading || leadData?.status === 11}
                     min={0}
                     className="w-full"
                     step="0.01"
                     addonBefore="$"
                     formatter={(value) => thousandAutoDecimal(value)}
                     parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                     onChange={(obj) => setLeadData({
                       ...leadData,
                       grossDealAmount: checkNumber(obj, 2)
                     })}
                   />
                 </DescriptionsItem>
                 <DescriptionsItem label={t('deal_amount')}>
                   <InputNumber
                     value={leadData?.dealAmount}
                     disabled={lead?.asSetter || loading || leadData?.status === 11}
                     min={0}
                     className="w-full"
                     step="0.01"
                     addonBefore="$"
                     formatter={(value) => thousandAutoDecimal(value)}
                     parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                     onChange={(obj) => setLeadData({
                       ...leadData,
                       dealAmount: checkNumber(obj, 2)
                     })}
                   />
                 </DescriptionsItem>
                 <DescriptionsItem label={t('panel_size')}>
                   <div className="flex gap-2">
                     <InputNumber
                       value={leadData?.panelSize}
                       disabled={lead?.asSetter || loading || leadData?.status === 11}
                       min={0}
                       className="w-full"
                       step="0.01"
                       formatter={(value) => thousandAutoDecimal(value)}
                       parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                       onChange={(obj) => setLeadData({
                         ...leadData,
                         panelSize: obj
                       })}
                     />
                   </div>
                 </DescriptionsItem>
                 <DescriptionsItem label={t('panel_amount')}>
                   <div className="flex gap-2">
                     <InputNumber
                       value={leadData?.panelAmount}
                       disabled={lead?.asSetter || loading || leadData?.status === 11}
                       min={0}
                       className="w-full"
                       step="1"
                       formatter={(value) => thousandAutoDecimal(value)}
                       parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                       onChange={(obj) => setLeadData({
                         ...leadData,
                         panelAmount: checkNumber(obj, 0)
                       })}
                     />
                   </div>
                 </DescriptionsItem>
                 <DescriptionsItem label={t('system_size')}>
                   <div className="flex gap-2">
                     <Button
                       type="primary"
                       className={lead?.asSetter ? 'hidden' : ''}
                       onClick={() => setSizeCalculator(true)}
                     >
                      {t('size_calculator')}
                     </Button>
                     <InputNumber
                       value={leadData?.systemSize}
                       disabled={lead?.asSetter || loading || leadData?.status === 11}
                       min={0}
                       className="w-full"
                       step="0.01"
                       formatter={(value) => thousandAutoDecimal(value)}
                       parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                       onChange={(obj) => setLeadData({
                         ...leadData,
                         systemSize: checkNumber(obj, 2)
                       })}
                     />
                   </div>
                 </DescriptionsItem>
                 <DescriptionsItem label={t('battery_brand')}>
                    <Select
                      showSearch
                      className="w-full h-12"
                      filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
                      value={leadData?.batteryBrand}
                      disabled={lead?.asSetter || loading || leadData?.status === 11}
                      onChange={(obj) => setLeadData({
                        ...leadData,
                        batteryBrand: obj
                      })}
                    >
                      {_.map(batteryBrands, (bb) => (
                        <Option value={bb.name}>{bb.name}</Option>
                      ))}
                    </Select>
                 </DescriptionsItem>
                 <DescriptionsItem label={t('batteries_amount')}>
                  <InputNumber
                    value={leadData?.batteriesAmount}
                    disabled={lead?.asSetter || loading || leadData?.status === 11}
                    min={0}
                    className="w-full"
                    step="1"
                    formatter={(value) => thousandAutoDecimal(value)}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    onChange={(obj) => setLeadData({
                      ...leadData,
                      batteriesAmount: checkNumber(obj, 0)
                    })}
                  />
                 </DescriptionsItem>
                  <DescriptionsItem label={t('payment_type')}>
                    <Select
                      className="w-full h-12"
                      value={leadData?.paymentType}
                      disabled={lead?.asSetter || loading || leadData?.status === 11}
                      onChange={(obj) => setLeadData({
                        ...leadData,
                        paymentType: obj
                      })}
                    >
                      {_.map(paymentTypes, (g) => (
                        <Option value={g.id}>{t(g.name)}</Option>
                      ))}
                    </Select>
                  </DescriptionsItem> 
                  <DescriptionsItem label={t('payment_amount')}>
                   <InputNumber
                     value={leadData?.paymentAmount}
                     disabled={lead?.asSetter || loading || leadData?.status === 11}
                     min={0}
                     className="w-full"
                     step="0.01"
                     addonBefore="$"
                     formatter={(value) => thousandAutoDecimal(value)}
                     parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                     onChange={(obj) => setLeadData({
                       ...leadData,
                       paymentAmount: checkNumber(obj, 2)
                     })}
                   />
                  </DescriptionsItem>
                  <DescriptionsItem label={t('deal_id')}>
                    <Input
                      value={leadData?.externalDealId}
                      disabled={lead?.asSetter || loading || leadData?.status === 11}
                      onChange={(obj) => setLeadData({
                        ...leadData,
                        externalDealId: obj.target.value
                      })}
                    />
                  </DescriptionsItem>
                  <DescriptionsItem label={t('installer')}>
                    <Select
                      showSearch
                      className="w-full h-12"
                      filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
                      value={leadData.contactType}
                      loading={loading}
                      disabled={loading}
                      onChange={(obj) => setLeadData({
                       ...leadData,
                       installer: obj
                      })}
                    >
                      {_.map(installers, (c) => (
                        <Option value={c.id}>{t(c.name)}</Option>
                      ))}
                    </Select>
                  </DescriptionsItem>
               </Descriptions>
             </TabPane>           
             
             {/* Tab 4: Survey Answers */}
             <TabPane tab={t('survey_answers')} key="4">
               <Descriptions bordered>
                <DescriptionsItem label={t('deal_type')}>
                  <Select
                    className="w-full h-12"
                    value={leadData?.dealType}
                    disabled={lead?.asSetter || loading || leadData?.status === 11}
                    onChange={(obj) => setLeadData({
                      ...leadData,
                      dealType: obj
                    })}
                  >
                    {_.map(dealTypes, (g) => (
                      <Option value={g.id}>{t(g.name)}</Option>
                    ))}
                  </Select>
                </DescriptionsItem>    
                <DescriptionsItem label={t('age_group')}>
                  <Select
                    showSearch
                    className="w-full h-12"
                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    value={leadData?.ageGroup}
                    disabled={lead?.asSetter || loading || leadData?.status === 11}
                    onChange={(obj) => setLeadData({
                      ...leadData,
                      ageGroup: obj
                    })}
                  >
                    {_.map(ageGroups, (g) => (
                      <Option value={g.id}>{t(g.name)}</Option>
                    ))}
                  </Select>
                </DescriptionsItem>
                <DescriptionsItem label={t('salary_group')}>
                  <Select
                    showSearch
                    className="w-full h-12"
                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    value={leadData?.salaryGroup}
                    disabled={lead?.asSetter || loading || leadData?.status === 11}
                    onChange={(obj) => setLeadData({
                      ...leadData,
                      salaryGroup: obj
                    })}
                  >
                    {_.map(salaryGroups, (g) => (
                      <Option value={g.id}>{t(g.name)}</Option>
                    ))}
                  </Select>
                </DescriptionsItem>
                <DescriptionsItem label={t('property_owner')}>
                  <Switch
                    checked={leadData?.isPropertyOwner}
                    disabled={lead?.asSetter || loading || leadData?.status === 11}
                    onChange={(obj) => setLeadData({
                      ...leadData,
                      isPropertyOwner: obj
                    })}
                  />
                </DescriptionsItem>
                <DescriptionsItem label={t('monthly_bill')}>
                  <Select
                    showSearch
                    className="w-full h-12"
                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    value={leadData?.averageMonthlyPaymentGroup}
                    disabled={lead?.asSetter || loading || leadData?.status === 11}
                    onChange={(obj) => setLeadData({
                      ...leadData,
                      averageMonthlyPaymentGroup: obj
                    })}
                  >
                    {_.map(averageMonthlyPaymentGroups, (g) => (
                      <Option value={g.id}>{t(g.name)}</Option>
                    ))}
                  </Select>
                </DescriptionsItem>
                <DescriptionsItem label={t('credit_score')}>
                  <Select
                    showSearch
                    className="w-full h-12"
                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    value={leadData?.creditScoreGroup}
                    disabled={lead?.asSetter || loading || leadData?.status === 11}
                    onChange={(obj) => setLeadData({
                      ...leadData,
                      creditScoreGroup: obj
                    })}
                  >
                    {_.map(creditScoreGroups, (g) => (
                      <Option value={g.id}>{t(g.name)}</Option>
                    ))}
                  </Select>
                </DescriptionsItem>
                {/* <DescriptionsItem className="hidden" label={t('roof_type')}>
                  <Select
                    showSearch
                    className="w-full h-12 hidden"
                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    value={leadData?.roofType}
                    disabled={lead?.asSetter || loading || leadData?.status === 11}
                    onChange={(obj) => setLeadData({
                      ...leadData,
                      roofType: obj
                    })}
                  >
                    {_.map(roofTypes, (g) => (
                      <Option value={g.id}>{t(g.name)}</Option>
                    ))}
                  </Select>
                </DescriptionsItem> */}            
               </Descriptions>
             </TabPane>

             {/* Tab 5: Commissions & Payouts */}
             {!lead?.asSetter && (
               <TabPane tab={t('commissions_and_payouts')} key="5">   
                 <Descriptions className="flex flex-col grid grid-cols-1" bordered>     
                   {!lead?.asSetter && (
                    <>
                      <DescriptionsItem label={t('closer_commision_pct')}>
                        <span>{percentage(leadData?.closerCommisionPCT * 100, 2)}</span>
                      </DescriptionsItem>
                      <DescriptionsItem label={t('closer_commision_amount')}>
                        <span>{toCurrency(leadData?.closerCommisionAmount)}</span>
                      </DescriptionsItem>
                      <DescriptionsItem label={t('setter_commision_amount')}>
                       <span>{toCurrency(leadData?.setterCommisionAmount)}</span>
                      </DescriptionsItem>
                      <DescriptionsItem label={t('effective_closer_commision_amount')}>
                        <span>{toCurrency(leadData?.closerCommisionAmount - leadData?.setterCommisionAmount)}</span>
                      </DescriptionsItem>
                      <DescriptionsItem label={t('recommended_for_payment')}>
                        <div className="flex">
                          <Switch
                            checked={leadData?.recommendedSetterPay}
                            className="mx-auto"
                            onChange={(checked) => setLeadData({
                              ...leadData,
                              recommendedSetterPay: checked
                            })}
                          />
                        </div>
                      </DescriptionsItem>
                    </>
                   )}
                   {lead?.asSetter && leadData?.payoutDate && (
                     <DescriptionsItem label={t('setter_commision_amount')}>
                       <span>{toCurrency(leadData?.setterCommisionAmount)}</span>
                     </DescriptionsItem>
                   )}
                   {!lead?.asSetter && (
                     <DescriptionsItem label={t('scheduled_payout_date')}>
                       <p>{leadData?.payoutDate ? toFormattedLocalDate(leadData?.payoutDate) : '-'}</p>
                     </DescriptionsItem>
                   )}
                 </Descriptions>
               </TabPane>
             )}

             {/* Tab 6: NEM */}
             <TabPane tab="NEM" key="6">
               <Descriptions bordered>
                 <DescriptionsItem label={t('step_one_completion')}>
                   <DatePicker
                     format="YYYY-MM-DD"
                     className="w-full"
                     inputReadOnly
                     onChange={(date) => {
                       setLeadData({
                         ...leadData,
                         nemStepOneDate: date
                       })
                     }}
                     value={leadData?.nemStepOneDate ? dayjs(leadData?.nemStepOneDate) : null}
                     showSecond={false}
                     type="primary"
                     size="small"
                     renderExtraFooter={() => getMobileDatePickerFooter(t)}
                     placement="bottomLeft"
                   />
                 </DescriptionsItem>
                  <DescriptionsItem label={t('step_two_completion')}>
                    <DatePicker
                      format="YYYY-MM-DD"
                      className="w-full"
                      inputReadOnly
                      onChange={(date) => {
                        setLeadData({
                          ...leadData,
                          nemStepTwoDate: date
                        })
                      }}
                      value={leadData?.nemStepTwoDate ? dayjs(leadData?.nemStepTwoDate) : null}
                      showSecond={false}
                      type="primary"
                      size="small"
                      renderExtraFooter={() => getMobileDatePickerFooter(t)}
                      placement="bottomLeft"
                    />
                  </DescriptionsItem>
                 <DescriptionsItem label={t('email')}>
                    <Input
                      value={leadData?.nemPortalEmail}
                      disabled={loading}
                      onChange={(obj) => setLeadData({
                        ...leadData,
                        nemPortalEmail: obj.target.value
                      })}
                    />
                 </DescriptionsItem>
                 <DescriptionsItem label={t('username')}>
                    <Input
                      value={leadData?.nemPortalUsername}
                      disabled={loading}
                      onChange={(obj) => setLeadData({
                        ...leadData,
                        nemPortalUsername: obj.target.value
                      })}
                    />
                 </DescriptionsItem>
                 <DescriptionsItem label={t('password')}>
                    <Input
                      value={leadData?.nemPortalPassword}
                      disabled={loading}
                      type={showPassword.password ? 'text' : 'password'}
                      suffix={(
                        <button
                          type="button"
                          onClick={() => setShowPassword({
                            ...showPassword,
                            password: !showPassword.password
                          })}
                        >
                          <FontAwesomeIcon icon={showPassword.password ? faEye : faEyeSlash} />
                        </button>
                      )}
                      onChange={(obj) => setLeadData({
                        ...leadData,
                        nemPortalPassword: obj.target.value
                      })}
                    />
                 </DescriptionsItem>
                 <DescriptionsItem label={t('ssn_last_4')}>
                    <Input
                      value={leadData?.nemLast4SSN}
                      type={showPassword.ssn ? 'text' : 'password'}
                      suffix={(
                        <button
                          type="button"
                          onClick={() => setShowPassword({
                            ...showPassword,
                            ssn: !showPassword.ssn
                          })}
                        >
                          <FontAwesomeIcon icon={showPassword.ssn ? faEye : faEyeSlash} />
                        </button>
                      )}
                      disabled={loading}
                      onChange={(obj) => setLeadData({
                        ...leadData,
                        nemLast4SSN: obj.target.value
                      })}
                    />
                 </DescriptionsItem>
                 <DescriptionsItem label={t('job')}>
                    <Input
                      value={leadData?.nemJob}
                      disabled={loading}
                      onChange={(obj) => setLeadData({
                        ...leadData,
                        nemJob: obj.target.value
                      })}
                    />
                 </DescriptionsItem>
               </Descriptions>
             </TabPane>

             {/* Tab 7: Other */}
             <TabPane tab={t('other')} key="7">
               <Descriptions bordered> 
                <DescriptionsItem span={4} label={t('notes')}>
                  <Input
                    value={leadData?.notes}
                    disabled={lead?.asSetter || loading || leadData?.status === 11}
                    onChange={(obj) => setLeadData({
                      ...leadData,
                      notes: obj.target.value
                    })}
                  />
                </DescriptionsItem>
                <DescriptionsItem label={t('referred_by')}>
                  <p>{leadData?.referredBy?.nameEn}</p>
                </DescriptionsItem>
                <DescriptionsItem label={t('referred_by_customer')}>
                  <Switch
                    checked={leadData?.referredByCustomer}
                    onChange={(obj) => setLeadData({
                      ...leadData,
                      referredByCustomer: obj
                    })}
                  />
                </DescriptionsItem>
               </Descriptions>
             </TabPane>
            </Tabs>
          </Spin>
        )}
      </Modal>
      <Modal
        title={t('setter')}
        zIndex={999}
        open={openSetter}
        onCancel={() => setOpenSetter(false)}
        footer={[
          <Button
            key="close"
            type="primary"
            onClick={() => setOpenSetter(false)}
          >
            {t('close')}
          </Button>
        ]}
      >
        <div className="flex space-x-2">
          <Dropdown
            trigger="click"
            placement="bottom"
            overlay={
              <Menu>
                {_.map(setters, (u) => (
                  <Popconfirm
                    title={t('assign_user_to_lead_prompt')}
                    okText={t('yes')}
                    cancelText={t('no')}
                    onConfirm={() => {
                      assignSetter(u);
                      setSearchText('');
                      setSetters([]);
                    }}
                  >
                    <Menu.Item
                      key={u.id}
                    >
                      <span>
                        <Avatar src={u.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                        {u.completeName}: {u.email}
                      </span>
                    </Menu.Item>
                  </Popconfirm>
                ))}
              </Menu>
            }
          >
            <Input.Search
              placeholder={`${t('search_users')}...`}
              allowClear
              className="mt-4"
              disabled={loading}
              loading={searchingUsers}
              enterButton={t('search')}
              size="small"
              value={searchText}
              onChange={(obj) => {
                setSearchText(obj.target.value);
                if (obj.target.value.length === 0) {
                  setSetters([]);
                }
              }}
              onClear={() => setSetters([])}
              onSearch={(val) => searchSetters()}
            />
          </Dropdown>
        </div>
        <Divider orientation="left">
          {t('assigned_setter')}
        </Divider>
        {leadData?.setter && (
          <div className="flex">
            <span>
              <Avatar src={leadData?.setter?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
              {leadData?.setter?.completeName}
            </span>
            <Popconfirm
              title={t('remove_setter_prompt')}
              okText={t('yes')}
              cancelText={t('no')}
              onConfirm={() => removeSetter()}
            >
              <button className="text-red-400 text-lg ml-auto" aria-label={t('remove_setter')} type="button">
                <FontAwesomeIcon icon={faTimesCircle} />
              </button>
            </Popconfirm>
          </div>
        )}
        {!leadData?.setter && (
          <div className="text-gray-400 text-center italic">N/A</div>
        )}
      </Modal>
      <Modal
        title={t('system_size_calculator')}
        zIndex={999}
        open={sizeCalculator}
        onCancel={() => {
          setSizeCalculator(false);
        }}
        footer={[
          <>
            {(panelSize * numPanels) < minimumSystemSize && (
              <Popconfirm
                title={t('are_you_sure_use_current_system_size_prompt')}
                okText={t('yes')}
                cancelText={t('no')}
                onConfirm={() => {
                  setLeadData({
                    ...leadData,
                    systemSize: (panelSize * numPanels)
                  });
                  setSizeCalculator(false);
                }}
              >
                <Button
                  key="ok"
                  type="primary"
                  disabled={panelSize <= 0 || numPanels <= 0}
                >
                  {t('set_size')}
                </Button>
              </Popconfirm>
            )}
            {(panelSize * numPanels) >= minimumSystemSize && (
              <Button
                key="ok"
                type="primary"
                disabled={panelSize <= 0 || numPanels <= 0}
                onClick={() => {
                  setLeadData({
                    ...leadData,
                    systemSize: (panelSize * numPanels),
                    panelSize,
                    panelAmount: numPanels
                  });
                  setSizeCalculator(false);
                }}
              >
                {t('set_size')}
              </Button>
            )}
          </>
        ]}
      >
        <div className="flex space-x-2">
          <div>
            <strong className="text-xs">{t('number_of_panels')}</strong>
            <br />
            <InputNumber
              value={numPanels}
              min={0}
              className="grow"
              step="1"
              formatter={(value) => thousandAutoDecimal(value)}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              onChange={(obj) => setNumPanels(obj)}
            />
          </div>
          <span className="mt-6">x</span>
          <div>
            <strong className="text-xs">{t('panel_size')}</strong>
            <br />
            <InputNumber
              value={panelSize}
              min={0}
              className="grow"
              step="1"
              formatter={(value) => thousandAutoDecimal(value)}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              onChange={(obj) => setPanelSize(obj)}
            />
          </div>
          <span className="mt-6">= {thousandAutoDecimal(panelSize * numPanels)}</span>
        </div>
        <Divider>
          {t('or')}
        </Divider>
        <div>
          <p>1. {t('enter_panel_size_above')}</p>
          <p>2. {t('upload_bill_consumption_history_image')}</p>
          <Dragger className="h-28" disabled={uploadingFile || panelSize <= 0} {...draggerProps}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {t('click_or_drag_content')}
            </p>
          </Dragger>
          <Button
            type="primary"
            className="w-full mt-2"
            onClick={() => analyze()}
            loading={uploadingFile}
            disabled={panelSize <= 0 || !fileData}
          >
            {t('analyze')}
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default LeadModal;
